<template>
    <div>
        <loader/>
        <div class="container-fluid">
            <br>
        <div>
        <b-row>
          <b-col>
            <div class="m-3">
             <h1 class="titlequestion">{{$t('extras.ext1')}}</h1>
            </div>
          </b-col>
          <b-col >
            <div class="m-3 text-right">
             <b-button @click="select_extras_gtm()" v-if="accion_modificar" squared class="button ml-3 mr-3" router-link :to="{ name: 'modificarReserva'}">{{$t('buttons_label.continue_review')}}</b-button>
             <b-button @click="select_extras_gtm()" v-else squared class="button ml-3 mr-3" router-link :to="{ name: 'Reservestep5'}">{{$t('buttons_label.continue_review')}}</b-button>
            </div>
          </b-col>
        </b-row>
        </div>
        <!-- ////// COVERAGES //////   -->
        <div class="mt-3">
            <b-row>
                <b-col class="d-none d-sm-none d-md-block"></b-col>
                <b-col md="9">
                    <div class="text-center">
                        <h2 class="titleextra">{{$t('extras.ext2')}}</h2>
                        <br>
                    </div>
                    <!-- Coverages web -->
                    <div class="d-none d-sm-none d-md-block" style="border-top: solid 3px rgb(0, 0, 0) !important;">
                        <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addEdd}">
                            <div class="">
                                <b-row class="mt-3" style="background:#f9f9f9">
                                    <b-col>
                                        <p v-if="$i18n.locale==='es'" class="titlesection"><b>{{calculo.detalle.coberturas.nombre[0]}}</b></p>
                                        <p v-else class="titlesection"><b>Deductible exoneration</b></p>
                                    </b-col>
                                    <b-col>
                                        <p class="dinregular">US${{parseFloat(calculo.detalle.coberturas.monto[0]/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                                    </b-col>
                                    <b-col>
                                        <div class="cardetailtext mb-4">
                                        <p class="cardetailtext" v-b-toggle="'collapsecar'+calculo.detalle.coberturas.siglas[0]">
                                        <img src="/img/arrowdown.png" class="mr-2">
                                        {{$t('extras.ext5')}}
                                        </p>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <a 
                                            href="#" 
                                            v-if="!addEdd"
                                            @click.prevent="addItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[0],
                                                                        nombre:calculo.detalle.coberturas.nombre[0],
                                                                        monto:calculo.detalle.coberturas.monto[0]})" 
                                            class="ml-3 cardetailtext">
                                            <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-plus-circle-fill" fill="#169a5a" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z"/>
                                            </svg> 
                                            {{$t('extras.ext6')}}
                                        </a>
                                        <a 
                                            href="#" 
                                            v-else
                                            @click.prevent="removeItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[0],
                                                                        nombre:calculo.detalle.coberturas.nombre[0],
                                                                        monto:calculo.detalle.coberturas.monto[0]})" 
                                            class="ml-3 cardetailtext">
                                            {{$t('extras.ext7')}}
                                        </a>
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- collapse -->
                            <b-collapse 
                            :id="'collapsecar'+calculo.detalle.coberturas.siglas[0]" 
                            class="carcard"
                            style=""
                            >
                            <b-card class="rounded-0" style="background:#f9f9f9">
                            
                            <div class=" mt-3">
                                <p class="text-left">{{$t('extras.ext8')}}</p>
                            </div>
                            </b-card>
                            </b-collapse>
                        </div>

                        <!--OTRA COBERTURA-->
                        <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addCap}">
                            <div class="">
                                <b-row class="mt-3" style="background:#f9f9f9">
                                    <b-col>
                                        <p v-if="$i18n.locale==='es'" class="titlesection"><b>{{calculo.detalle.coberturas.nombre[1]}}</b></p>
                                        <p v-else class="titlesection"><b>Deductible exoneration</b></p>
                                    </b-col>
                                    <b-col>
                                        <p class="dinregular">US${{parseFloat(calculo.detalle.coberturas.monto[1]/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                                    </b-col>
                                    <b-col>
                                        <div class="cardetailtext mb-4">
                                        <p class="cardetailtext" v-b-toggle="'collapsecar'+calculo.detalle.coberturas.siglas[1]">
                                        <img src="/img/arrowdown.png" class="mr-2">
                                        {{$t('extras.ext5')}}
                                        </p>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <a 
                                            href="#" 
                                            v-if="!addCap" 
                                            @click.prevent="addItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[1],
                                                                        nombre:calculo.detalle.coberturas.nombre[1],
                                                                        monto:calculo.detalle.coberturas.monto[1]})" 
                                            class="ml-3 cardetailtext">
                                            <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-plus-circle-fill" fill="#169a5a" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z"/>
                                            </svg> 
                                            {{$t('extras.ext6')}}
                                        </a>
                                        <!--si se seleccionó la cobertura-->
                                        <a 
                                            href="#" 
                                            v-if="addCap" 
                                            @click.prevent="removeItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[1],
                                                                        nombre:calculo.detalle.coberturas.nombre[1],
                                                                        monto:calculo.detalle.coberturas.monto[1]})" 
                                            class="ml-3 cardetailtext">
                                            {{$t('extras.ext7')}}
                                        </a>
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- collapse -->
                            <b-collapse 
                            :id="'collapsecar'+calculo.detalle.coberturas.siglas[1]" 
                            class="carcard"
                            style=""
                            >
                            <b-card class="rounded-0" style="background:#f9f9f9">
                            
                            <div class=" mt-3">
                                <p class="text-left">{{$t('extras.ext9')}}</p>
                            </div>
                            </b-card>
                            </b-collapse>
                        </div>
                        <!--OTRA COBERTURA-->
                        <!--OTRA COBERTURA-->
                        <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addClp}">
                            <div class="">
                                <b-row class="mt-3" style="background:#f9f9f9">
                                    <b-col>
                                        <p v-if="$i18n.locale==='es'" class="titlesection"><b>{{calculo.detalle.coberturas.nombre[2]}}</b></p>
                                        <p v-else class="titlesection"><b>Deductible exoneration</b></p>
                                    </b-col>
                                    <b-col>
                                        <p class="dinregular">US${{parseFloat(calculo.detalle.coberturas.monto[2]/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                                    </b-col>
                                    <b-col>
                                        <div class="cardetailtext mb-4">
                                        <p class="cardetailtext" v-b-toggle="'collapsecar'+calculo.detalle.coberturas.siglas[2]">
                                        <img src="/img/arrowdown.png" class="mr-2">
                                        {{$t('extras.ext5')}}
                                        </p>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <a 
                                            href="#" 
                                            v-if="!addClp" 
                                            @click.prevent="addItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[2],
                                                                        nombre:calculo.detalle.coberturas.nombre[2],
                                                                        monto:calculo.detalle.coberturas.monto[2]})" 
                                            class="ml-3 cardetailtext">
                                            <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-plus-circle-fill" fill="#169a5a" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z"/>
                                            </svg> 
                                            {{$t('extras.ext6')}}
                                        </a>
                                        <!--si se seleccionó la cobertura-->
                                        <a 
                                            href="#" 
                                            v-if="addClp" 
                                            @click.prevent="removeItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[2],
                                                                        nombre:calculo.detalle.coberturas.nombre[2],
                                                                        monto:calculo.detalle.coberturas.monto[2]})" 
                                            class="ml-3 cardetailtext">
                                            {{$t('extras.ext7')}}
                                        </a>
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- collapse -->
                            <b-collapse 
                            :id="'collapsecar'+calculo.detalle.coberturas.siglas[2]" 
                            class="carcard"
                            style=""
                            >
                            <b-card class="rounded-0" style="background:#f9f9f9">
                            
                            <div class=" mt-3">
                                <p class="text-left">{{$t('extras.ext10')}}</p>
                            </div>
                            </b-card>
                            </b-collapse>
                        </div>
                        <!--OTRA COBERTURA-->
                        <!--OTRA COBERTURA-->
                        <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addRap}">
                            <div class="">
                                <b-row class="mt-3" style="background:#f9f9f9">
                                    <b-col>
                                        <p v-if="$i18n.locale==='es'" class="titlesection"><b>{{calculo.detalle.coberturas.nombre[3]}}</b></p>
                                        <p v-else class="titlesection"><b>Deductible exoneration</b></p>
                                    </b-col>
                                    <b-col>
                                        <p class="dinregular">US${{parseFloat(calculo.detalle.coberturas.monto[3]/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                                    </b-col>
                                    <b-col>
                                        <div class="cardetailtext mb-4">
                                        <p class="cardetailtext" v-b-toggle="'collapsecar'+calculo.detalle.coberturas.siglas[3]">
                                        <img src="/img/arrowdown.png" class="mr-2">
                                        {{$t('extras.ext5')}}
                                        </p>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <a 
                                            href="#" 
                                            v-if="!addRap" 
                                            @click.prevent="addItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[3],
                                                                        nombre:calculo.detalle.coberturas.nombre[3],
                                                                        monto:calculo.detalle.coberturas.monto[3]})" 
                                            class="ml-3 cardetailtext">
                                            <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-plus-circle-fill" fill="#169a5a" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z"/>
                                            </svg> 
                                            {{$t('extras.ext6')}}
                                        </a>
                                        <!--si se seleccionó la cobertura-->
                                        <a 
                                            href="#" 
                                            v-if="addRap" 
                                            @click.prevent="removeItem({
                                                                        sigla:calculo.detalle.coberturas.siglas[3],
                                                                        nombre:calculo.detalle.coberturas.nombre[3],
                                                                        monto:calculo.detalle.coberturas.monto[3]})" 
                                            class="ml-3 cardetailtext">
                                            {{$t('extras.ext7')}}
                                        </a>
                                    </b-col>
                                </b-row>
                            </div>
                            <!-- collapse -->
                            <b-collapse 
                            :id="'collapsecar'+calculo.detalle.coberturas.siglas[3]" 
                            class="carcard"
                            style=""
                            >
                            <b-card class="rounded-0" style="background:#f9f9f9">
                            
                            <div class=" mt-3">
                                <p class="text-left">{{$t('extras.ext11')}}</p>
                            </div>
                            </b-card>
                            </b-collapse>
                        </div>
                        <!--OTRA COBERTURA-->
                    </div>
                    <br><br>
                </b-col>
                <b-col class="d-none d-sm-none d-md-block"></b-col>
            </b-row>
            <!--accesorios-->
            <b-row>
                <b-col class="d-none d-sm-none d-md-block"></b-col>
                <b-col md="9">
                    <div class="text-center">
                        <h2 class="titleextra">{{$t('extras.acc1')}}</h2>
                        <br>
                    </div>
                    <div class="d-none d-sm-none d-md-block" style="border-top: solid 3px rgb(0, 0, 0) !important;">
                        <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addMifi}">
                            <b-row class="mt-3" style="background:#f9f9f9">
                                <b-col>
                                    <p class="titlesection"><b>{{calculo.detalle.accesorios.nombre[0]}}</b></p>
                                </b-col>
                                <b-col>
                                    <p class="dinregular">US${{parseFloat(calculo.detalle.accesorios.monto[0]/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                                </b-col>
                                <b-col>
                                    <div class="cardetailtext mb-4">
                                    <p class="cardetailtext" v-b-toggle="'collapsecar'+calculo.detalle.accesorios.siglas[0]">
                                    <img src="/img/arrowdown.png" class="mr-2">
                                    {{$t('extras.ext5')}}
                                    </p>
                                    </div>
                                </b-col>
                                <b-col>
                                <!--si no se ha seleccionado el accesorio-->
                                    <a 
                                    href="#"
                                    v-if="!addMifi" 
                                    @click.prevent="addItem({
                                                                sigla:calculo.detalle.accesorios.siglas[0],
                                                                nombre:calculo.detalle.accesorios.nombre[0],
                                                                monto:calculo.detalle.accesorios.monto[0]})"
                                                            class="ml-3 cardetailtext">
                                    <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-plus-circle-fill" fill="#169a5a" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z"/>
                                    </svg>
                                        {{$t('extras.ext6')}}
                                    </a>
                                
                                <!--si se seleccionó el accesorio-->
                                <a 
                                    href="#" 
                                    v-if="addMifi" 
                                    @click.prevent="removeItem({
                                                                sigla:calculo.detalle.accesorios.siglas[0],
                                                                nombre:calculo.detalle.accesorios.nombre[0],
                                                                monto:calculo.detalle.accesorios.monto[0]})" 
                                    class="ml-3 cardetailtext">
                                    {{$t('extras.ext7')}}
                                </a>
                            </b-col>
                            </b-row>
                            <b-collapse 
                                :id="'collapsecar'+calculo.detalle.accesorios.siglas[0]" 
                                class="carcard"
                                style=""
                                >
                                <b-card class="rounded-0" style="background:#f9f9f9">
                                
                                <div class=" mt-3">
                                    <p class="text-left">{{$t('extras.acc2')}}</p>
                                </div>
                                </b-card>
                                </b-collapse>
                        </div>

                        <!--OTRO ACCESORIO-->
                        <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addSillabb}">
                            <b-row class="mt-3" style="background:#f9f9f9">
                                <b-col>
                                    <p class="titlesection"><b>{{calculo.detalle.accesorios.nombre[1]}}</b></p>
                                </b-col>
                                <b-col>
                                    <p class="dinregular">US${{parseFloat(calculo.detalle.accesorios.monto[1]/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                                </b-col>
                                <b-col>
                                    <div class="cardetailtext mb-4">
                                    <p class="cardetailtext" v-b-toggle="'collapsecar'+calculo.detalle.accesorios.siglas[1]">
                                    <img src="/img/arrowdown.png" class="mr-2">
                                    {{$t('extras.ext5')}}
                                    </p>
                                    </div>
                                </b-col>
                                <b-col>
                                <!--si no se ha seleccionado el accesorio-->
                                    <a 
                                    href="#"
                                    v-if="!addSillabb" 
                                    @click.prevent="addItem({
                                                                sigla:calculo.detalle.accesorios.siglas[1],
                                                                nombre:calculo.detalle.accesorios.nombre[1],
                                                                monto:calculo.detalle.accesorios.monto[1]})"
                                                            class="ml-3 cardetailtext">
                                    <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-plus-circle-fill" fill="#169a5a" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z"/>
                                    </svg>
                                        {{$t('extras.ext6')}}
                                    </a>
                                
                                <!--si se seleccionó el accesorio-->
                                <a 
                                    href="#" 
                                    v-if="addSillabb" 
                                    @click.prevent="removeItem({
                                                                sigla:calculo.detalle.accesorios.siglas[1],
                                                                nombre:calculo.detalle.accesorios.nombre[1],
                                                                monto:calculo.detalle.accesorios.monto[1]})" 
                                    class="ml-3 cardetailtext">
                                    {{$t('extras.ext7')}}
                                </a>
                            </b-col>
                            </b-row>
                            <b-collapse 
                                :id="'collapsecar'+calculo.detalle.accesorios.siglas[1]" 
                                class="carcard"
                                style=""
                                >
                                <b-card class="rounded-0" style="background:#f9f9f9">
                                
                                <div class=" mt-3">
                                    <p class="text-left">{{$t('extras.acc3')}}</p>
                                </div>
                                </b-card>
                                </b-collapse>
                        </div>
                    </div>
                    <!-- <div class="m-3 text-right">
                        <b-button v-if="accion_modificar" squared class="button " router-link to="/modificar-reserva">{{$t('buttons_label.continue_review')}}</b-button>
                        <b-button v-else squared class="button " router-link to="/reservestep5">{{$t('buttons_label.continue_review')}}</b-button>
                    </div> -->
                    <br><br>
                </b-col>
                <b-col class="d-none d-sm-none d-md-block"></b-col>
            </b-row>
            <!--conductor adicional-->
        <b-row>
          <b-col class="d-none d-sm-none d-md-block"></b-col>
          <b-col md="9">
            <div class="text-center">
              <h2 class="titleextra">{{$t('extras.drv1')}}</h2>
              <br>
            </div>
            <!-- accesories web -->
            <div class="d-none d-sm-none d-md-block" style="border-top: solid 3px rgb(0, 0, 0) !important;">
           
              <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addCondAdic}">
                <b-row class="mt-3" style="background:#f9f9f9">
                  <b-col>
                    <p class="titlesection"><b>{{$t('extras.drv2')}}</b></p>
                  </b-col>
                  <b-col>
                    <p class="dinregular">US${{parseFloat(calculo.detalle.conductor_adicional/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                  </b-col>
                  <b-col>
                    <div class="cardetailtext mb-4">
                       <p class="cardetailtext" v-b-toggle="'collapsecar'">
                       <img src="/img/arrowdown.png" class="mr-2">
                       {{$t('extras.ext5')}}
                       </p>
                     </div>
                  </b-col>
                  <b-col>
                         
                      <b-button-group>
                        <b-button squared  @click="removeConductor()">-</b-button>
                        <b-button variant="link"><span :class="data.conductor_adicional >= 1 ? 'cont1': 'cont'">{{ data.conductor_adicional }}</span></b-button>
                        <b-button squared  @click="addConductor()">+</b-button>
                      </b-button-group>
                    
                    <!-- <button class="btn btn-secondary mr-5 " @click="MT_QUITARCONDUCTOR(calculo.detalle.conductor_adicional)">-</button>
                      <span class="cont">{{ data.conductor_adicional }}</span>
                    <button class="btn btn-secondary ml-5" @click="MT_AGREGARCONDUCTOR(calculo.detalle.conductor_adicional)">+</button> -->
                  </b-col>
                </b-row>
                <!-- collapse -->
                <b-collapse 
                :id="'collapsecar'" 
                class="carcard"
                style=""
                >
                  <b-card class="rounded-0" style="background:#f9f9f9">
                   
                   <div class=" mt-3">
                     <p class="text-left">{{$t('extras.drv2')}}</p>
                   </div>
                  </b-card>
                </b-collapse>
              </div>
            </div>
            <!-- conductor mobile -->
            <div class="d-md-none d-lg-none d-xl-none" style="border-top: solid 3px rgb(0, 0, 0) !important;">
              <!-- 1st accesorie -->
              <div class="text-center" style="border-bottom: solid 2px #b8b8b8 !important;" :class="{'selected':addCondAdic}">
                <b-row class="mt-3" style="background:#f9f9f9">
                  <b-col cols="">
                    <p class="titlesection"><b>{{$t('extras.drv2')}}</b></p>
                  </b-col>
                  <b-col cols="12">
                    
                      <b-button-group>
                        <b-button squared variant="secondary" @click="removeConductor(calculo.detalle.conductor_adicional)">-</b-button>
                        <b-button variant="link"><span :class="data.conductor_adicional >= 1 ? 'cont1': 'cont'">{{ data.conductor_adicional }}</span></b-button>
                        <b-button squared variant="secondary" @click="addConductor()">+</b-button>
                      </b-button-group>
                    
                  </b-col>
                  <b-col cols="12">
                    <p class="dinregular">US${{parseFloat(calculo.detalle.conductor_adicional/calculo.reserva.cant_dias).toFixed(2)}}/ {{$t('extras.ext4')}}</p>
                  </b-col>
                  <b-col cols="12">
                    <div class="cardetailtext mb-4">
                       <p class="cardetailtext" v-b-toggle="'coductor'">
                       <img src="/img/arrowdown.png" class="mr-2">
                       {{$t('extras.ext5')}}
                       </p>
                     </div>
                  </b-col>
                  
                </b-row>
                <!-- collapse -->
                <b-collapse 
                :id="'coductor'" 
                class="carcard"
                style=""
                >
                  <b-card class="rounded-0" style="background:#f9f9f9">
                   
                   <div class=" mt-3">
                     <p class="text-left">{{$t('extras.drv2')}}</p>
                   </div>
                  </b-card>
                </b-collapse>
              </div>
              
            </div>
            <div class="m-3 text-right">
             <b-button @click="select_extras_gtm()" v-if="accion_modificar" squared class="button " router-link :to="{ name: 'modificarReserva'}">{{$t('buttons_label.continue_review')}}</b-button>
             <b-button @click="select_extras_gtm()" v-else squared class="button " router-link :to="{ name: 'Reservestep5'}">{{$t('buttons_label.continue_review')}}</b-button>
            </div>
            <br><br>
          </b-col>
          <b-col class="d-none d-sm-none d-md-block"></b-col>
        </b-row>
        </div>
        </div>
    </div>
</template>

<script>
import loader                     from '@/components/loader.vue'
import moment from 'moment'
import { mapState, mapMutations, mapActions } from 'vuex'
import { useGtm } from '@gtm-support/vue2-gtm';

    export default {
        components: {
            loader,
        },
        data() {
            return {
                covers: {
                    EDD: {
                        monto:"",
                        nombre:"",
                        sigla:"EDD",
                    },
                    CAP: {
                        monto:"",
                        nombre:"",
                        sigla:"CAP",
                    },
                    CLP: {
                        monto:"",
                        nombre:"",
                        sigla:"CLP",
                    },
                    RAP: {
                        monto:"",
                        nombre:"",
                        sigla:"RAP",
                    }
                },
                accesorios: {
                    sillabb: {
                        monto: "",
                        nombre: "",
                        sigla: "MW"

                    },
                    mifi: {
                        monto: "",
                        nombre: "",
                        sigla: "SB"
                    }
                }
            }
        },
        mounted () {
            console.log(moment().format('h:mm:ss'));
        },
        watch: {
            'addEdd': function (val, oldval) {
              if (val==true) {
                  //console.log('addEdd', val, this.covers.EDD.monto)
                  this.covers.EDD.monto = this.data.coberturas[0].monto
                  this.covers.EDD.nombre = this.data.coberturas[0].nombre
              }  
            },
             'addCap': function (val, oldval) {
               if (val==true) {
                   //console.log('addCap', val)
                   this.covers.CAP.monto = this.data.coberturas[1].monto
                   this.covers.CAP.nombre = this.data.coberturas[1].nombre
               }  
             },
            'addClp': function (val, oldval) {
              if (val==true) {
                  //console.log('addClp', val)
                  this.covers.CLP.monto = this.data.coberturas[2].monto
                  this.covers.CLP.nombre = this.data.coberturas[2].nombre
              }  
            },
             'addRap': function (val, oldval) {
               if (val==true) {
                   //console.log('addRap', val)//Revisar por aquí, que no llega monto, pero tampoco veo que afecta
                   this.covers.RAP.monto = this.data.coberturas[3].monto
                   this.covers.RAP.nombre = this.data.coberturas[3].nombre
               }  
             },
             'addMifi': function (val, oldval) {
               if (val==true) {
                   //console.log('addMifi', val)
                    this.accesorios.mifi.monto = this.data.accesorios[0].monto
                    this.accesorios.mifi.nombre = this.data.accesorios[0].nombre
               }  
             },
             'addSillabb': function (val, oldval) {
               if (val==true) {
                   //console.log('addSillabb', val)
                   this.accesorios.sillabb.monto = this.data.accesorios[1].monto
                   this.accesorios.sillabb.nombre = this.data.accesorios[1].nombre
               }  
             },
             'addCondAdic': function (val, oldval) {
               if (val==true) {
                   //console.log('addCondAdic', val)
               }  
             },
        },
        computed: {
            ...mapState('reservav2', ['auto','calculo','data','detalles', 'accion_modificar', 'procesoReserva', 'addEdd', 'addCap','addClp', 'addRap', 'addMifi', 'addSillabb', 'addCondAdic'])
        },
        methods: {
            ...mapActions('reservav2', ['addItem', 'removeItem', 'addConductor', 'removeConductor']),

        select_extras_gtm(){
          //console.log('select_extras_gtm', this.calculo)
          const gtm = useGtm();

          gtm.trackEvent({
              'event': 'checkout',
              'category' : 'ecommerce',        //Static data
              'action' : 'select extras',      // Static data
              
             //Enhanced Ecommerce - UA
              'ecommerce': {
                'currencyCode': 'USD',
                'checkout':{ 
                      'actionField': {
                        'step': 4, 
                        'option': 'select extras',}
                       },
                'products': [
                 {
                   'name': this.auto.modelo,
                   'id': this.auto.id,
                   'brand': this.auto.marca,
                   'category': this.auto.categoria.categoria, 
                    // Category/Category2/Category3
                   'list': 'Vehículos | Selecciona el tipo de vehículos',
                   'index': this.auto.categoria.orden,
                   'price': this.calculo.detalle.tarifa,
                   'coupon': '',
                   'quantity': '1',
                    //Custom dimensions at product level
                   'extras': this.covers.EDD.nombre+', '+this.covers.CLP.nombre+', '+this.covers.CAP.nombre+', '+this.covers.RAP.nombre+', '+this.accesorios.sillabb.nombre+', '+this.accesorios.mifi.nombre, //CD16
                   'prepay_price': '',                                 //CM2
                   'pay_destination': '',                              //CM3
                },
                {
                   'name': this.covers.EDD.nombre,
                   'id': 'EDD',
                   'list_id': '0',
                   'list_name': 'Coberturas',
                   'index': 0,
                   'price': this.covers.EDD.monto,
                   'quantity': '1'
                },
                {
                   'name': this.covers.CLP.nombre,
                   'id': 'CLP',
                   'list_id': '1',
                   'list_name': 'Coberturas',
                   'index': 1,
                   'price': this.covers.CLP.monto,
                   'quantity': '1'
                },
                {
                   'name': this.covers.CAP.nombre,
                   'id': 'CAP',
                   'list_id': '2',
                   'list_name': 'Coberturas',
                   'index': 2,
                   'price': this.covers.CAP.monto,
                   'quantity': '1'
                },
                {
                   'name': this.covers.RAP.nombre,
                   'id': 'RAP',
                   'list_id': '3',
                   'list_name': 'Extras',
                   'index': 3,
                   'price': this.covers.RAP.monto,
                   'quantity': '1'
                },
                {
                   'name': this.accesorios.sillabb.nombre,
                   'id': 'SB',
                   'list_id': '1',
                   'list_name': 'Accesorios',
                   'index': 1,
                   'price': this.accesorios.sillabb.monto,
                   'quantity': '1'
                },
                {
                   'name': this.accesorios.mifi.nombre,
                   'id': 'MW',
                   'list_id': '0',
                   'list_name': 'Accesorios',
                   'index': 0,
                   'price': this.accesorios.mifi.monto,
                   'quantity': '1'
                }
            ]
               },
            })
            
          } 

        },
    }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.titleextra{
  color: #333333; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 28px;
  font-weight: 600;
}
.carcard{
  background:#f3f3f3 !important;
}
.cartitle{
   color: #181918; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 25px;
   font-weight: 400;
   height: 29px;
   line-height: 29.1667px;
   margin: 0px 0px 5px;
   padding: 0px;
   width: 459px;
}
.carsubtitle{
   color: #656565; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 14px;
   font-weight: 300;
   height: 19px;
   line-height: normal;
   margin: 0px 0px 10px;
   padding: 0px;
   width: 459px;
}
.carsmalltext{
   color: #656565; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 12px;
   font-weight: 300;
}
.cardetailtext{
   color: #169a5a; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 15px;
   font-weight: 600;
   text-decoration: none;
}
.cardetailtext:focus {
  outline: 2px solid #a4ceff !important;
}
.caricons{
   color: #656565 !important;
   height: 16px;
   width:  16px;
}

.cartitletext{
  color: #181918; 
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  font-size: 14px;
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 15px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.filtertitle{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #333333 !important;
    font-size: 14px;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.noline{
  text-decoration: none;
}

.selected{
  background-color: #006639;
  color: #fff;

    .titlesection{
      color: #fff;
    }

    .cardetailtext{
       color: #fff;
    }

    .card{
      background-color: #006639;
    }
}

/* /////////// CHECKBOX //////////////  */
/* The customcheck */
.customcheck {
    display: block;
    position: relative;
    padding-left: 35px;
    padding-top: 5px;
    margin-bottom: 22px;
    font-size: 14px;
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: -14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.customcheck input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 28px;
    width:  28px;
    background-color: rgb(255, 255, 255);
    border-radius: 0px;
    border: solid 2px #b8b8b8;
}

/* On mouse-over, add a grey background color */
.customcheck:hover input ~ .checkmark {
    background-color: #eee;
}

/* When the checkbox is checked, add a blue background */
.customcheck input:checked ~ .checkmark {
    background-color: #ffffff;
    border-radius: 0px;
    border: solid 3px #169a5a;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.customcheck input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.customcheck .checkmark:after {
    left: 6px;
    top: 3px;
    width: 10px;
    height: 12px;
    border: solid 2px #169a5a;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.cont{
  color: black;
}
.cont1{
  color: rgb(255, 255, 255);
}
</style>